import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import MessageListUI from './MessageListUI'

class MessageListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      taskMessageList: null,
      messageUserList: null,
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
    this.refreshComments = null // when user clicks refresh, capture the value
  }

  render() {
    return (
      <MessageListUI
        context={this.props.context}
        messageList={this.state.messageList}
        taskMessageList={this.state.taskMessageList}
        messageUserList={this.state.messageUserList}
        projectUserMap={this.props.projectUserMap}
        projectUserList={this.props.projectUserList}
        project={this.props.project}
        task={this.props.task}
        //
        scrollToBottom={this.props.scrollToBottom}
        onMessageListUpdate={this.onMessageListUpdate}
        onForceTaskListRefresh={this.props.onForceTaskListRefresh}
        onForceTaskMessageListRefresh={this.onForceTaskMessageListRefresh}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTaskMessages(context, this.props.task.taskId)
    this.getTaskMessageUsers(context, this.props.task.taskId)
    this.getMessages(context)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
      this.setState({taskMessageList: null, messageUserList: null})
      this.getTaskMessages(props.context, props.task.taskId)
      this.getTaskMessageUsers(props.context, props.task.taskId)
    }
    else if (props.refreshComments && props.refreshComments !== this.refreshComments) {
      this.refreshComments = props.refreshComments
      this.setState({taskMessageList: null})
      CacheManager.removeObject(CacheKeys.TaskMessages(this.taskId))
      this.getTaskMessages(props.context, this.taskId)
    }
  }

  // get --------------------------------------
  getTaskMessages(context, taskId) {
    let cacheManager = new CacheManager({
      resource: `/api/tasks/${taskId}/messages`,
      cacheKey: CacheKeys.TaskMessages(taskId),
      callback: this.getTaskMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskMessagesCallback = (response) => {
    this.setState({taskMessageList: response.taskMessageList})
    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }
  }

  onForceTaskMessageListRefresh = (taskId) => {
    CacheManager.removeObject(CacheKeys.TaskMessages(taskId))
    this.setState({taskMessageList: null}, this.getTaskMessages(this.props.context, taskId))
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound' && error.objectCode === 'Task')
        this.props.onForceTaskListRefresh(this.props.task.projectId)
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onMessageListUpdate = taskMessageList => {
    this.setState({taskMessageList: taskMessageList})
  }

  getTaskMessageUsers(context, taskId) {
    let cacheManager = new CacheManager({
      resource: `/api/tasks/${taskId}/message-users`,
      cacheKey: CacheKeys.TaskMessageUsers(taskId),
      callback: this.getTaskMessageUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskMessageUsersCallback = (response) => {
    this.setState({
      messageUserList: response.taskMessageUserList,
    })
  }

  getMessages(context) {
    let arr = [
      'c_add',
      'c_update',
      'c_delete',
      'c_cancel',
      'c_add_comment',
      'c_last_update',
      'c_no_comments'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('c_tsk_msgs', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default MessageListSF
